import {
    Pipe, PipeTransform
} from "@angular/core";
import {
    ObjectUtil, StringUtil
} from "@shopliftr/common-js/data";

/**
 * This pipe will add cache buster to the given url to invalidate cache
 * example: url | mgdUrlCacheBuster : cacheBuster
 * Normally we use Date.now() as the cache buster
 */
@Pipe({ name: "mgdUrlCacheBuster" })
export class UrlCacheBusterPipe implements PipeTransform {

    /**
     * Implements the transform function in PipeTransform interface
     * @param value the given url
     * @param cacheBuster the cache buster we want to use, normally Date.now()
     * @returns the cache-busted url
     */
    transform(value: string, cacheBuster: number): string {

        if (StringUtil.emptyString(value) || !ObjectUtil.isDefined(cacheBuster)) {
            return value ?? "";
        }
        if (value.includes("?")) {
            return `${value}&cache-buster=${cacheBuster}`;
        }
        else {
            return `${value}?cache-buster=${cacheBuster}`;
        }
    }
}
